import { render, staticRenderFns } from "./BasePieChart.vue?vue&type=template&id=460d5310&scoped=true"
import script from "./BasePieChart.vue?vue&type=script&lang=js"
export * from "./BasePieChart.vue?vue&type=script&lang=js"
import style0 from "./BasePieChart.vue?vue&type=style&index=0&id=460d5310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d5310",
  null
  
)

export default component.exports